import React, { useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RootLayout from "./layouts/Root";
import ErrorPage from "./pages/error/Error";
import Calculation from "./pages/Dashboard/Calculation/Calculation";
import PaperInstruction from "./pages/Dashboard/PaperInstructions/PaperInstruction";
import SignIn from "./pages/Login/SignIn";
import SignUp from "./pages/Login/SignUp";
import ForgotPassword from "./pages/Login/ForgotPassword";
import ResetPassword from "./pages/Login/ResetPassword";
import SecurePayment from "./pages/Dashboard/SecurePayment/SecurePayment"
import SuccessPayment from "./pages/Dashboard/SecurePayment/SuccessPayment"
import MyOrders from "./pages/Orders/MyOrders"
import PendingOrders from "./pages/Orders/PendingOrders"
import InOProgressOrders from "./pages/Orders/InProgressOrders";
import RaiseComplaint from "./pages/Orders/RaiseComplaintOrders";
import RaiseComplaintForm from "./pages/Orders/RaiseComplaintForm";
import Thread from "./pages/Thread/Thread";
import { WaitingPage } from "./pages/Login/WaitingPage";
import { PublicRoute, ProtectedRoute, OtpRouteGuard } from "./components/protectedAndPublicRoutex";
import RedirectToExternal from "./components/RedirectToExternal";
import Otp from "./pages/Login/Otp";
import { VerifyEmail } from "./pages/Login/VerifyEmail";
import { useSelector } from "react-redux";
import Profile from "./pages/Profile/Profile";
import MyWallet from "./pages/Wallet/MyWallet";
import PaymentErrorPage from "./pages/error/PaymentError";
import Dashboard from "./pages/Dashboard/Dashboard/Dashboard";
import ServerError from "./pages/error/ServerError";
import { UseConfirmationTesting } from "./pages/UseConfirmationTesting";

const router = createBrowserRouter([

    /* ====================================> PROTECTED ROUTES <========================================= */
    {
        path: "/",
        element: <ProtectedRoute />,
        errorElement: <ErrorPage />,
        children: [
            {
                element: <RootLayout />,
                children: [
                    { index: true, element: <Dashboard initialCount={10} /> },
                    { path: "dashboard" , element: <Dashboard/>},
                    { path: "edit-profile", element: <Profile /> },
                    { path: "calculation", element: <Calculation /> },
                    { path: "paper-instructions", element: <PaperInstruction /> },
                    { path: "secure-payment/*", element: <SecurePayment /> },
                    { path: "success-payment/*", element: <SuccessPayment /> },
                    { path: "my-orders", element: <MyOrders /> },
                    { path: "pending-orders", element: <PendingOrders/> },
                    { path: "in-progress", element: <InOProgressOrders/> },
                    { path: "raise-complaint", element: <RaiseComplaint /> },
                    { path: "raise-complaint-forms", element: <RaiseComplaintForm /> },
                    { path: "my-wallet", element: <MyWallet/> },

                ],
            },
        ],
    },
    {
        path: "/thread",
        element: <ProtectedRoute />,
        errorElement: <ErrorPage />,
        children: [{ path: "", element: <Thread /> }],
    },

    /* ========================================> PUBLIC ROUTES <================================================ */
    {
        path: "/",
        element: <PublicRoute />,
        errorElement: <ErrorPage />,
        children: [
            { index: true, element: <SignIn /> },
            { path: "signin", element: <SignIn /> },
            { path: "signup", element: <SignUp /> },
            { path: "forgot-password", element: <ForgotPassword /> },
            { path: "reset-password", element: <ResetPassword /> },
            { path: "google", element: <WaitingPage /> },
            { path: "verify-email", element: <VerifyEmail/>},
            {
                path: "/otp",
                element: <OtpRouteGuard />,
                children: [
                    { path: "", element: <Otp /> }  
                ]
            },
            {
                path: "contact-us",
                element: <RedirectToExternal uri={"https://coursepivot.com/contact/"}/>
            },
            {
                path: "privacy-policy",
                element: <RedirectToExternal uri={"https://coursepivot.com/privacy-policy/"}/>
            },
            {
                path: "about-us",
                element: <RedirectToExternal uri={"https://coursepivot.com/services/"}/>
            },
            {
                path: "terms-and-conditions",
                element: <RedirectToExternal uri={"https://coursepivot.com/terms-and-conditions/"}/>
            },
            {
                path: "server-error",
                element: <ServerError/>
            },
            {
                path: "use-confirm",
                element: <UseConfirmationTesting />
            },
        ],
    },
    {
        path: "/payment-error",
        element: <PaymentErrorPage />,
    },
]);

function App() {

    const user = useSelector((state)=> state.auth)
    useEffect(() => {
        // console.log(user)
    },[user])

    return <RouterProvider router={router} />;
}

export default App;